<div class="col-md-12 col-lg-4 paginationDiv">
    <ul class="pagination">
        <li *ngIf="page!=1 && page-5>0" class="page-item ng-star-inserted" (click)="prevPage()"><a aria-label="Previous" href="javascript:void(0)" class="page-link"><span aria-hidden="true" class="ng-star-inserted">&lt;</span></a></li>
        <li *ngFor="let p of totalPages.slice(page-5>0?page-5:0, page+5>totalPages.length?totalPages.length:page+5)" class="page-item ng-star-inserted" (click)="changePage(p)"><a aria-label="page" href="javascript:void(0)" [ngClass]="'page-link' + (page==p ? ' page-active' : '')"><span aria-hidden="true" class="ng-star-inserted">{{p}}</span></a></li>
        <li *ngIf="page+5<totalPages.length" class="page-item ng-star-inserted" (click)="nextPage()"><a aria-label="Next" href="javascript:void(0)" class="page-link"><span aria-hidden="true" class="ng-star-inserted">&gt;</span></a></li>
    </ul>

    <!--ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" aria-label="Default pagination" (pageChange)="changePage($event)"></ngb-pagination-->
</div>
<div class="col-md-12 col-lg-4 lg-center paginationDiv">
    <div class="mt-2 text-center">Items: <b>{{ start+1 }}-{{ end }}</b> of <b>{{ collectionSize }}</b> </div>
</div>
<div class="col-md-12 col-lg-4 lg-end paginationDiv">
    <div class="m-0 mt-2 text-center">
        <div>Items per page:
            <span>
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-blue-small btn-page" id="dropdownBasic1" ngbDropdownToggle>{{ pageSize }}</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem (click)="selectPage(5)">5</button>
                        <button ngbDropdownItem (click)="selectPage(10)">10</button>
                        <button ngbDropdownItem (click)="selectPage(20)">20</button>
                    </div>
                </div>
            </span>
        </div>
    </div>
</div>